export default function Procedura(props) {
	return <span id="a11y-procedura">{props.children}</span>;
}
